import { useMutation } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { guacHttpClient } from "@/lib/http";
import { Candidacy, HttpResponse } from "@/types";

export function useDeleteCandidacy() {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();

  const mutation = useMutation({
    mutationFn: async ({ candidacyId }: { candidacyId: string }) => {
      const path = `companies/${currentCompanyId}/jobs/${currentJobId}/candidacies/${candidacyId}`;
      const res = await guacHttpClient.delete<
        Candidacy,
        HttpResponse<Candidacy>
      >(path);

      return res.data;
    },
  });

  return mutation;
}
